// src/components/ErrorPage.js

import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import HeaderBottom from '../HomePage/HeaderBottom';

const ErrorPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    

<>
<HeaderBottom></HeaderBottom>
 
  <div className="error-section-area sp3 mt-5">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 m-auto">
          <div className="error-content text-center">
            <img src="https://i.ibb.co.com/LXQM7M63/404-img.png" alt="" />
            <div className="space60" />
            <div class="error-container">
        <div class="error-code one-head">404</div>
        <h2 class="error-message">Oops! Page Not Found</h2>
        <p>The page you are looking for might have been removed or is temporarily unavailable.</p>
        <a href="/" class="btn btn-primary fs-2">Go to Homepage</a>
    </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</>



    
  );
};

export default ErrorPage;
